// Placements
export const PLACEMENT_RIGHT = 'docked_right';
export const PLACEMENT_BOTTOM = 'docked_bottom';
export const PLACEMENT_MODAL = 'modal';
